export default __webpack_public_path__ + "static/media/users.a993c013.svg";